import React from 'react';
import { convertStyles, isIOS } from '@kibt/krn-utils';
import SrcStyles from './index.styl';
import { PageContext, KView, KText, KScrollView, KImage } from '@/component/RtlLayout';
import { lang, SCENE } from '@/common/const';
import { View, Text } from 'react-native';
import Image from '@kds/image';
import ArrowRight from '../ArrowRight';
import CheckedPng from '@/assets/images_detail/checkedNew.png';
import unCheckPng from '@/assets/images_detail/uncheckNew.png';
import addIconPng from '@/assets/images_detail/addIcon.png';
import miaoshaIcon from '@/assets/images_detail/miaoshaIcon.png';
import ArrowIcon from '@/assets/icon/arrow_right_grey.png';
import BottomNodeCom from './BottomNode';
import { CheckoutDetailPopup } from './hooks/CheckoutDetailPopup';
import { useCoudanInfoStore } from './coudanInfoStore';
import { $k18n } from '@/common/i18n';
import { MakeUpPopup } from './hooks/MakeUpPopup';
import Toast from '@/component/Toast/Toast';
import { useJumpToGoodsDetailPage } from '@/common/biz/jump';
import SpecPop from '@/component/SpecPop/SpecPop';
import { logger } from '@/common/log';
import { LogShow, ViewVisible } from '@/component/ViewVisible/ViewVisible';
import { k18nPro } from './BottomNode/k18npro';
import { styles } from '@/common/style';
import arrowTopRed from '@/assets/icon_detail/kibt_arrow-top-red.png';
import TextSwipper from '@/component/ScrollSwipper';
import LinearGradient from 'react-native-linear-gradient';
import { afterPv } from '@/common/utils/afterPv';
import CropImage from '@/business-components/CropImage';
import { useQuery } from '@/hooks/useQuery';
import { useDetailPageStore } from '@/page/detail/store';
import { useAddCartItemFromCommercialFloorApi, useMakeUpApi } from './hooks/useCoudanApi';
import { useExtParamsObject } from '../../utils';
import { useJumpToCart } from '../../../jump';
import { isWeb } from '@/common/device-info';
import { useABHandler } from '../../../useABHandler';
import { getEncryptionFormat } from '@/common/api-for-decode-base';
import { KTouchableWithoutFeedback } from '@/component/RtlLayout/Touchable';
import { useParams } from 'react-router';

const Styles = convertStyles(SrcStyles);

export function DetailMakeUp() {
    const { detailABValueMap: showDetailCoudan } = useABHandler();
    const addressInfo = useDetailPageStore().getState().addressInfo as any;
    const { makeUpItems } = useMakeUpApi();
    const routerParams = useParams();
    const { itemId } = useDetailPageStore(s => ({
        itemId: s.itemId,
    }));
    const scene = useQuery<string>('scene') || SCENE.DEFAULT_SCENE;
    const extParams = useExtParamsObject();
    const { addCartItemFromCommercialFloor } = useAddCartItemFromCommercialFloorApi();
    const { jumpToCart } = useJumpToCart();

    const { showSpecPop, curPopCartItem, extraInfo, discountTip, recoItems, makeUpPopupVisible } = useCoudanInfoStore(s => ({
        showSpecPop: s.showSpecPop,
        curPopCartItem: s.curPopCartItem,
        extraInfo: s.extraInfo,
        discountTip: s.discountTip,
        recoItems: s.recoItems,
        makeUpPopupVisible: s.makeUpPopupVisible,
    }));

    const pageRawData = useDetailPageStore(s => s.pageRawData);

    const handleMakeUpItems = selectProducts => {
        makeUpItems(
            selectProducts,
            {
                postCode: addressInfo?.postalCode,
                province: addressInfo?.provinceName,
                city: addressInfo?.cityName,
                strict: addressInfo?.streetName,
            },
            getEncryptionFormat(),
            itemId,
            scene
        );
    };

    const handleCoudanAddTocar = async selectProducts => {
        const merchantId = pageRawData?.merchantId;
        const mediaId = Number(itemId); // 传当前商品的itemid
        const selected = selectProducts.map((item, index) => {
            const { skuId } = item;
            return {
                itemId: item.itemId,
                skuId,
                num: item.quantity,
                mediaId: item.itemId === itemId ? extParams.cId : Number(itemId), // 选中的是当前商品，传当前页面的参数， 别的传当前商详的 itemId
                mediaSource: item.itemId === itemId ? extParams.cT : 30, // 选中的是当前商品，传当前页面的参数， 别的传30
                mediaDetailSource: extParams.cS,
                sellerMerchantId: item.itemId === itemId ? (pageRawData.sellerMerchantShop && pageRawData.sellerMerchantShop.merchantId) || 0 : null, // 只有选中的是当前商品 可能传
            };
        });
        const res = await addCartItemFromCommercialFloor(merchantId, mediaId, selected);
        if (res) {
            if (res?.result === 1) {
                const { addFailType, count } = res?.data;
                if (addFailType === 1) {
                    Toast.show({ text: $k18n({ id: 'k_355119', text: '添加成功' }) });
                }
                if (addFailType === 2) {
                    if (count === 0) {
                        Toast.show({ text: $k18n({ id: 'add_failed_all' }) });
                    } else {
                        Toast.show({ text: $k18n({ id: 'k_420458', text: '部分商品由于信息变更加购失败' }) });
                    }
                }

                // 表明有加购成功的
                if (count > 0 && (addFailType === 1 || addFailType === 2)) {
                    // iosrn tip 需要等Model先关闭 不关闭的话，无法实现跳走
                    if (isIOS && !isWeb) {
                        setTimeout(() => {
                            jumpToCart({ halfWebview: false, addressId: addressInfo?.id || addressInfo?.addressId });
                        }, 2200);
                    } else {
                        setTimeout(() => {
                            jumpToCart({ halfWebview: false, addressId: addressInfo?.id || addressInfo?.addressId });
                        }, 1600);
                    }
                }
            }
        }
    };
    const setCoudanStore = useCoudanInfoStore().setState;

    const beUncheck = item => {
        logger.sendClick({
            action: 'BOUGHT_TOGETHER_PRODUCT_CARD',
            params: {
                item_id: item?.itemId,
                seckill_tag: item?.activityInfo?.activityId ? 1 : 0, // 秒杀表示
                product_discount: item?.discountRate, // 商品折扣
                product_type: item?.extra?.productType, //商品类别
                element_type: 0, // 0:商详页凑单楼层模块，1:商详页凑单半屏页
                click_area: 1, // 点击位置。0:商品卡片,1:商品卡片前方勾选按钮,2:规格选项,3:规格数量
            },
        });
        const idx = recoItems?.findIndex(recoiItem => recoiItem.itemId === item.itemId);
        const copyRecoItems = JSON.parse(JSON.stringify(recoItems));
        copyRecoItems[idx].extra.selected = false;
        setCoudanStore({ recoItems: copyRecoItems });
        const selectProducts = copyRecoItems
            .filter(i => i?.extra?.selected)
            .map(item => {
                return {
                    itemId: item.itemId,
                    skuId: item?.skus?.[item?.extra?.selectSkuIndex]?.skuId,
                    quantity: item?.skus?.[item?.extra?.selectSkuIndex]?.skuQuantity,
                };
            });
        handleMakeUpItems(selectProducts);
    };

    const beCheck = item => {
        logger.sendClick({
            action: 'BOUGHT_TOGETHER_PRODUCT_CARD',
            params: {
                item_id: item?.itemId,
                seckill_tag: item?.activityInfo?.activityId ? 1 : 0, // 秒杀表示
                product_discount: item?.discountRate, // 商品折扣
                product_type: item?.extra?.productType, //商品类别
                element_type: 0, // 0:商详页凑单楼层模块，1:商详页凑单半屏页
                click_area: 1, // 点击位置。0:商品卡片,1:商品卡片前方勾选按钮,2:规格选项,3:规格数量
            },
        });
        const idx = recoItems?.findIndex(recoiItem => recoiItem.itemId === item.itemId);
        const copyRecoItems = JSON.parse(JSON.stringify(recoItems));
        copyRecoItems[idx].extra.selected = true;
        setCoudanStore({ recoItems: copyRecoItems });
        const selectProducts = copyRecoItems
            .filter(i => i?.extra?.selected)
            .map(item => {
                return {
                    itemId: item.itemId,
                    skuId: item?.skus?.[item?.extra?.selectSkuIndex]?.skuId,
                    quantity: item?.skus?.[item?.extra?.selectSkuIndex]?.skuQuantity,
                };
            });
        handleMakeUpItems(selectProducts);
    };

    const clickAddtoCar = () => {
        const copyRecoItems = JSON.parse(JSON.stringify(recoItems));
        const selectProducts = copyRecoItems
            .filter(i => i?.extra?.selected)
            .map(item => {
                return {
                    itemId: item.itemId,
                    skuId: item?.skus?.[item?.extra?.selectSkuIndex]?.skuId,
                    quantity: item?.skus?.[item?.extra?.selectSkuIndex]?.skuQuantity,
                };
            });
        if (!selectProducts?.length) {
            Toast.show({ text: $k18n({ id: 'k_420456' }) });
            return;
        }
        handleCoudanAddTocar(selectProducts);
    };

    const getImageUrl = item => {
        const currentSku = item?.skus[item?.extra?.selectSkuIndex];
        // 优先使用 WEBP 的图片
        const skuImageUrl = currentSku?.templateImageUrl || currentSku?.imageUrl || item?.templateImageUrls?.[0] || item?.imageUrls?.[0];
        return skuImageUrl;
    };

    const showMore = () => {
        logger.sendClick({
            action: 'BOUGHT_TOGETHER_ARROW',
            params: {},
        });
        if (!makeUpPopupVisible) {
            logger.sendShow({
                action: 'BOUGHT_TOGETHER_HALF_PAGE',
                params: {},
            });
        }
        setCoudanStore({ makeUpPopupVisible: !makeUpPopupVisible });
    };

    const { jumpToGoodsDetailPage } = useJumpToGoodsDetailPage();

    function goDetail(item) {
        if (itemId === item?.itemId) {
            return;
        }
        logger.sendClick({
            action: 'BOUGHT_TOGETHER_PRODUCT_CARD',
            params: {
                item_id: item?.itemId,
                seckill_tag: item?.activityInfo?.activityId ? 1 : 0, // 秒杀表示
                product_discount: item?.discountRate, // 商品折扣
                product_type: item?.extra?.productType, //商品类别
                element_type: 0, // 0:商详页凑单楼层模块，1:商详页凑单半屏页
                click_area: 0, // 点击位置。0:商品卡片,1:商品卡片前方勾选按钮,2:规格选项,3:规格数量
            },
        });
        jumpToGoodsDetailPage({
            itemId: item.itemId,
            extParams: {
                cT: 30, // 新增枚举
                cId: itemId,
            },
        });
    }

    const onUpdateSpec = (sku, purchaseQuantity) => {
        console.log('onUpdateSpec', purchaseQuantity);
        const itemId = sku.itemId;
        const item = recoItems.find(v => v.itemId === itemId);
        const itemIndex = recoItems.findIndex(v => v.itemId === itemId);
        const skuIdIndex = item.skus.findIndex(i => i.skuId === sku.skuId);

        const copyRecoItems = JSON.parse(JSON.stringify(recoItems));
        copyRecoItems[itemIndex].extra.selectSkuIndex = skuIdIndex;
        copyRecoItems[itemIndex].skus[skuIdIndex].skuQuantity = purchaseQuantity;

        const selectProducts = copyRecoItems
            .filter(i => i?.extra?.selected)
            .map(item => {
                return {
                    itemId: item.itemId,
                    skuId: item?.skus?.[item?.extra?.selectSkuIndex]?.skuId,
                    quantity: item?.skus?.[item?.extra?.selectSkuIndex]?.skuQuantity,
                };
            });

        setCoudanStore({
            recoItems: copyRecoItems,
            showSpecPop: false,
        });
        handleMakeUpItems(selectProducts);
    };

    const onSpecClick = item => {
        logger.sendClick({
            action: 'BOUGHT_TOGETHER_PRODUCT_CARD',
            params: {
                item_id: item?.itemId,
                seckill_tag: item?.activityInfo?.activityId ? 1 : 0, // 秒杀表示
                product_discount: item?.discountRate, // 商品折扣
                product_type: item?.extra?.productType, //商品类别
                element_type: 0, // 0:商详页凑单楼层模块，1:商详页凑单半屏页
                click_area: 2, // 点击位置。0:商品卡片,1:商品卡片前方勾选按钮,2:规格选项,3:规格数量
            },
        });
        const itemNew = {
            ...item,
            skuId: item?.skus?.[item?.extra?.selectSkuIndex]?.skuId,
        };
        setCoudanStore({
            curPopCartItem: itemNew,
            showSpecPop: true,
        });
    };

    const clickSpecDesc = item => {
        if (showDetailCoudan?.if_product_addon_spec_modifiabe && item?.skus?.length > 1) {
            onSpecClick(item);
        }
    };

    const renderItem = items => {
        return items.map((item, index) => {
            const currentSku = item?.skus?.[item?.extra?.selectSkuIndex] || item?.skus[0];
            const renderPriceContent = () => {
                // salePrice不是活动价，则肯定是券后价
                if (currentSku.salePrice > 0 && currentSku.salePrice < currentSku.activityPrice) {
                    return (
                        <ViewVisible
                            onVisible={() => {
                                afterPv.then(() => {
                                    logger.sendShow({
                                        action: 'BOUGHT_TOGETHER_PRODUCT_CARD',
                                        params: {
                                            item_id: item?.itemId,
                                            seckill_tag: item?.activityInfo?.activityId ? 1 : 0, // 秒杀表示
                                            product_discount: item?.discountRate, // 商品折扣
                                            product_type: item?.extra?.productType, //商品类别
                                            element_type: 0, // 0:商详页凑单楼层模块，1:商详页凑单半屏页
                                        },
                                    });
                                });
                            }}>
                            <View style={{"marginTop":"0.9661835748792271rem"}}>
                                <Text style={{"fontSize":"2.8985507246376816rem","lineHeight":"3.381642512077295rem","color":"#FF4906"}}>
                                    {$k18n({ id: '1e202bd42f3b632dcf249fb70801e9e6', text: '券后价' })}
                                </Text>
                                <Text style={{"fontSize":"3.381642512077295rem","lineHeight":"3.8647342995169085rem","color":"#FF4906","fontWeight":"500","marginTop":"0.48309178743961356rem"}}>
                                    {currentSku?.displaySalePrice}
                                </Text>
                            </View>
                        </ViewVisible>
                    );
                }
                return (
                    <KView rtlClassName={'coudan-item-price-content'}>
                        <ViewVisible
                            onVisible={() => {
                                afterPv.then(() => {
                                    logger.sendShow({
                                        action: 'BOUGHT_TOGETHER_PRODUCT_CARD',
                                        params: {
                                            item_id: item?.itemId,
                                            seckill_tag: item?.activityInfo?.activityId ? 1 : 0, // 秒杀表示
                                            product_discount: item?.discountRate, // 商品折扣
                                            product_type: item?.extra?.productType, //商品类别
                                            element_type: 0, // 0:商详页凑单楼层模块，1:商详页凑单半屏页
                                        },
                                    });
                                });
                            }}>
                            <KText
                                rtlClassName={[
                                    'coudan-item-price-display-black',
                                    item?.marketPrice?.displayAmount ? 'coudan-item-price-display' : '',
                                ]}>
                                {currentSku?.displaySalePrice}
                            </KText>
                        </ViewVisible>

                        {currentSku?.skuMarketPrice ? (
                            <KText rtlClassName={'coudan-item-price-off'}>{currentSku?.displaySkuMarketPrice}</KText>
                        ) : item?.activityInfo?.activityId ? (
                            <KText rtlClassName={'coudan-item-price-off'}>{item?.itemPrice?.displayAmount}</KText>
                        ) : null}
                    </KView>
                );
            };
            return (
                <KTouchableWithoutFeedback key={index} onPress={() => goDetail(item)}>
                    <KView
                        rtlClassName={'coudan-item-wrapper'}
                        style={{
                            marginRight: index === recoItems?.length - 2 ? 42 : 12,
                        }}>
                        <KView rtlClassName={'coudan-item-content'}>
                            {currentSku?.discountRate ? (
                                <KView rtlClassName={'coudan-item-off'}>
                                    <KText rtlClassName={'coudan-item-off-text'}>{currentSku.discountRate}% OFF</KText>
                                    {item?.activityInfo?.activityId ? <KImage rtlClassName={'coudan-item-miaosha-img'} source={miaoshaIcon} /> : null}
                                </KView>
                            ) : null}

                            {item?.extra?.selected ? (
                                <KTouchableWithoutFeedback onPress={() => beUncheck(item)}>
                                    <KView rtlClassName={'coudan-item-check-img-wrapper'}>
                                        <KImage rtlClassName={'coudan-item-check-img'} source={CheckedPng} />
                                    </KView>
                                </KTouchableWithoutFeedback>
                            ) : (
                                <KTouchableWithoutFeedback onPress={() => beCheck(item)}>
                                    <KView rtlClassName={'coudan-item-check-img-wrapper'}>
                                        <KImage rtlClassName={'coudan-item-check-img'} source={unCheckPng} />
                                    </KView>
                                </KTouchableWithoutFeedback>
                            )}
                            <CropImage
                                style={{"width":"30.917874396135268rem","height":"30.917874396135268rem","borderRadius":"1.9323671497584543rem","borderWidth":"0.12077294685990339rem","borderColor":"rgba(0, 0, 0, 0.05)"}}
                                src={getImageUrl(item)}
                                width={128}
                                cropOption={{ ratio: 0.5, width: 128, height: 128 }}
                                height={128}
                                logParams={{
                                    itemId,
                                    position: 'detail-make-up',
                                }}
                            />
                            {/* <ImageWithBackground
                                style={{"width":"30.917874396135268rem","height":"30.917874396135268rem","borderRadius":"1.9323671497584543rem","borderWidth":"0.12077294685990339rem","borderColor":"rgba(0, 0, 0, 0.05)"}}
                                cropOption={{ ratio: 0.5 }}
                                source={{ uri: getImageUrl(item) }}
                            /> */}

                            {itemId === item?.itemId ? (
                                <KView rtlClassName={'coudan-item-tip-wrapper'}>
                                    <KView rtlClassName={'coudan-item-tip'}>
                                        <KText rtlClassName={'coudan-item-tip-text'}>{$k18n({ id: 'k_420453' })}</KText>
                                    </KView>
                                </KView>
                            ) : null}
                        </KView>
                        <KTouchableWithoutFeedback onPress={() => clickSpecDesc(item)}>
                            <KView rtlClassName={'coudan-item-sku-content'}>
                                <KView
                                    style={{"display":"flex","flexDirection":"row","justifyContent":"space-between","flexGrow":1,"alignItems":"center"}}>
                                    <KText numberOfLines={1} ellipsizeMode="tail" rtlClassName={'coudan-item-sku-content-text-left'}>
                                        {currentSku?.skuSpecDesc}
                                    </KText>
                                    <KText rtlClassName={'coudan-item-sku-content-text'}>x{currentSku?.skuQuantity}</KText>
                                </KView>

                                {item?.skus?.length > 1 && showDetailCoudan?.if_product_addon_spec_modifiabe ? (
                                    <Image source={ArrowIcon} style={{"width":"3.8647342995169085rem","height":"3.8647342995169085rem","transform":[{"rotate":"90deg"}],"marginLeft":"0.9661835748792271rem"}} />
                                ) : null}
                            </KView>
                        </KTouchableWithoutFeedback>
                        {renderPriceContent()}
                    </KView>
                </KTouchableWithoutFeedback>
            );
        });
    };

    const renderCoudanContentV1 = () => {
        if (recoItems?.length) {
            return (
                <KView rtlClassName={'CoudanWrapper'}>
                    <KView>
                        <KTouchableWithoutFeedback onPress={() => showMore()}>
                            <KView rtlClassName={'coudan-title-wrap'}>
                                <KText rtlClassName={'coudan-title-text'}>{$k18n({ id: 'k_420452' })}</KText>
                                <LogShow action="BOUGHT_TOGETHER_ARROW" params={{}}>
                                    <KView rtlClassName={'coudan-title-right'}>
                                        <ArrowRight />
                                    </KView>
                                </LogShow>
                            </KView>
                        </KTouchableWithoutFeedback>

                        <KScrollView horizontal={true} rtlClassName={'coudan-list'} showsHorizontalScrollIndicator={false}>
                            {recoItems?.length ? renderItem([recoItems?.[0]]) : null}

                            {recoItems?.length && recoItems?.length > 1 ? (
                                <KView rtlClassName={'coudan-item-add-icon'}>
                                    <KImage rtlClassName={'coudan-item-add-icon-img'} source={addIconPng} />
                                </KView>
                            ) : null}

                            {recoItems?.length ? renderItem(recoItems?.slice(1)) : null}
                        </KScrollView>

                        <KView rtlClassName={'bottom-btn-content'}>
                            <BottomNodeCom clickAddtoCar={clickAddtoCar} usefulType={'detailPage'} pageRawData={pageRawData} />
                        </KView>
                    </KView>
                </KView>
            );
        }
        return null;
    };

    const swiperText = () => {
        const textStyle = {
            border: styles({
                color: '#ff4906',
                fontWeight: '500',
            }),
            highLight: styles({
                color: '#ff4906',
                fontWeight: '500',
            }),
        };
        const getHighlightText = displayAmount => {
            return <KText style={textStyle.highLight}>{displayAmount}</KText>;
        };
        const keysArr = [];
        const replaceParams = (str: string) => {
            if (!str) return;
            return str?.replace(/\{(\w+)\}/g, (a, b) => {
                keysArr.push(b);
                return a;
            });
        };
        replaceParams(discountTip?.tip);
        if (!keysArr?.length) {
            return '';
        }
        const getParams = () => {
            const params = {};
            keysArr?.forEach((key, index) => {
                params[key] =
                    discountTip?.placeHolder?.[index]?.font === 1
                        ? getHighlightText(discountTip?.placeHolder?.[index]?.value)
                        : discountTip?.placeHolder?.[index]?.value;
            });
            return params;
        };

        const text = k18nPro({
            text: discountTip?.tip,
            params: getParams(),
        });
        return text;
    };

    const renderCoudanContentV2 = () => {
        return (
            <LinearGradient start={{ x: 0.0, y: 0.0 }} end={{ x: 0.0, y: 1.0 }} colors={['#fff6f3', '#ffffff']}>
                <KView
                    style={styles({
                        height: 40,
                        width: '100%',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        paddingHorizontal: 19,
                    })}>
                    <TextSwipper>{swiperText()}</TextSwipper>
                    <KTouchableWithoutFeedback
                        onPress={() => {
                            showMore();
                            afterPv.then(() => {
                                logger.sendClick({
                                    action: 'ADD_ON_BAR',
                                });
                            });
                        }}>
                        <KView
                            style={styles({
                                flexDirection: 'row',
                                alignItems: 'center',
                                marginLeft: 19,
                            })}>
                            <ViewVisible
                                onVisible={() => {
                                    afterPv.then(() => {
                                        logger.sendShow({
                                            action: 'ADD_ON_BAR',
                                        });
                                    });
                                }}>
                                <KText style={{"color":"#FF4906"}}>
                                    {k18nPro({
                                        id: 'k_352437',
                                        text: '去凑单',
                                    })}
                                </KText>
                            </ViewVisible>
                            <KImage
                                source={arrowTopRed}
                                style={{"width":"2.173913043478261rem","height":"2.173913043478261rem","marginLeft":"0.9661835748792271rem"}}
                                resizeMode="contain"
                            />
                        </KView>
                    </KTouchableWithoutFeedback>
                </KView>
            </LinearGradient>
        );
    };

    console.log('extraInfo?.version', extraInfo?.version);

    return extraInfo?.version ? (
        <PageContext.Provider value={{ Styles }}>
            <LogShow action="FREQUENTLY_BOUGHT_TOGETHER" params={{}}>
                {extraInfo?.version === 2 ? renderCoudanContentV2() : renderCoudanContentV1()}
                <CheckoutDetailPopup />
                <MakeUpPopup handleMakeUpItems={handleMakeUpItems} beCheck={beCheck} beUncheck={beUncheck} clickAddtoCar={clickAddtoCar} />
                <SpecPop
                    showChangeCount={true}
                    onConfirm={onUpdateSpec}
                    curPopItem={curPopCartItem}
                    showPop={showSpecPop}
                    closePop={() => setCoudanStore({ showSpecPop: false })}
                    isFrom={'detail-coudan'}
                />
            </LogShow>
        </PageContext.Provider>
    ) : null;
}
